import React from 'react';
import moment from 'moment';
import { Grid, Typography } from '@mui/material';
import { dateFormate } from 'utils/utils';
import pickup from 'assets/images/pickUp.svg';
import drop from 'assets/images/drop.svg';

function PickUp(props) {
  const tableData = props?.tableData
  return (
    <div className="heightPickUp" >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className='height7'
      >
        <Grid item xs={1} className='pickUpItem'>
          <div className='pickUpImg'></div>
          <img src={pickup} alt="star" className='pickUpPosition' /> 
        </Grid>
        <Grid item xs={11}>
          <Typography className="font14 fontSemi colorGrey"> Pick Up</Typography>
          <Typography className="font14 fontNormal">
            {tableData?.sourceAddress}
          </Typography>
          <Typography className="font12 fontNormal colorGrey">{moment((tableData?.pickUpTime && tableData?.pickUpTime !== null) ? tableData?.pickUpTime : tableData?.scheduledTime).format('DD MMM YYYY, hh:mm a')}</Typography>
          <Typography className="font12 fontNormal colorBlue">{tableData?.distance ?tableData?.distance+"KM" : '' }</Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className=''
      >
        <Grid item xs={1}>
          <div className='dropImg'><img src={drop} alt="star" /> </div>
        </Grid>
        <Grid item xs={11}>
          <Typography className="font14 fontSemi colorGrey"> {(tableData?.status?.toLowerCase() === 'completed' || tableData?.status?.toLowerCase() === 'cancelled') ? 'Dropped' : 'Dropping'} </Typography>
          <Typography className="font14 fontNormal">
            {tableData?.destinationAddress}
          </Typography>
          <Typography className="font12 fontNormal colorGrey">{tableData?.completedAt ? (dateFormate(tableData?.completedAt, 'DD MMM YYYY, hh:mm a')) : ''}</Typography>
        </Grid>
      </Grid>
    </div>
  );
}

export default PickUp;
